export enum ProfileStatus {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  PendingPayment = 3,
  // Temporary suspension: the user can still read the site but cannot write.
  Suspended = 4,
  // Permanent suspension: blocked entirely — login is rejected and every
  // authenticated request is denied by the backend.
  PermanentlySuspended = 5,
}
